<template>

    <div>

        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <label for="rut">Rut {{ sufijo }}</label>
                    <input type="text" name="rut" class="form-control" v-model="form.rut" required placeholder="Rut" maxlength="16" @blur="BuscarPersona()">
                </div>
            </div>

            <div class="col-md-4">
                <div class="form-group">
                    <label for="nombres">Nombres {{ sufijo }}</label>
                    <input type="text" name="nombres" class="form-control" v-model="form.nombres" required placeholder="Nombres" maxlength="191">
                </div>
            </div>

            <div class="col-md-4">
                <div class="form-group">
                    <label for="apellido_paterno">Apellido paterno {{ sufijo }}</label>
                    <input type="text" name="apellido_paterno" class="form-control" v-model="form.apellido_paterno" required placeholder="Apellido paterno" maxlength="191">
                </div>
            </div>

        </div>

        <div class="row">

            <div class="col-md-4">
                <div class="form-group">
                    <label for="apellido_materno">Apellido materno {{ sufijo }}</label>
                    <input type="text" name="apellido_materno" class="form-control" v-model="form.apellido_materno" required placeholder="Apellido materno" maxlength="191">
                </div>
            </div>

            <div class="col-md-4">
                <div class="form-group">
                    <label for="genero_id">Género {{ sufijo }}</label>
                    <select name="genero_id" id="genero_id" v-model="form.genero_id" class="form-control" placeholder="Seleccione género">
                        <option v-for="genero in form_data.generos" :value="genero.id" :key="genero.id">{{ genero.nombre }}</option>
                    </select>
                </div>
            </div>

            <div class="col-md-4">
                <div class="form-group">
                    <label for="nacionalidad_id">Nacionalidad {{ sufijo }}</label>
                    <select name="nacionalidad_id" id="nacionalidad_id" v-model="form.nacionalidad_id" class="form-control" placeholder="Seleccione nacionalidad">
                        <option v-for="nacionalidad in form_data.nacionalidades" :value="nacionalidad.id" :key="nacionalidad.codigo">{{ nacionalidad.nombre }}</option>
                    </select>
                </div>
            </div>

        </div>

        <div class="row">

            <div class="col-md-4">
                <div class="form-group">
                    <label for="email">Correo electrónico {{ sufijo }}</label>
                    <input type="email" name="email" class="form-control" v-model="form.email" placeholder="Correo electrónico" maxlength="191" :required="email_required">
                </div>
            </div>

            <div class="col-md-4">
                <div class="form-group">
                    <label for="email2">Correo electrónico secundario {{ sufijo }}</label>
                    <input type="email" name="email2" class="form-control" v-model="form.email2" placeholder="Correo electrónico secundario" maxlength="191">
                </div>
            </div>

            <div class="col-md-4">
                <div class="form-group">
                    <label for="telefono">Teléfono {{ sufijo }}</label>
                    <input type="tel" name="telefono" class="form-control" v-model="form.telefono" placeholder="Teléfono" maxlength="191">
                </div>
            </div>

        </div>

    </div>

</template>

<script>
    export default {
        data() {
            return {
                form: new window.Form({
                    rut: '',
                    nombres: '',
                	apellido_paterno: '',
                    apellido_materno: '',
                    genero_id: '',
                    nacionalidad_id: '',
                    email: '',
                    email2: '',
                    telefono: '',
                }),
                form_data: {
                    generos: [],
                    nacionalidades: [],
                },
                persona: null,
            }
        },
        props: {
            rut: {required: false, default: null},
            sufijo: {required: false, default: ""},
            email_required: {required: false, default: false},
        },
        mounted() {
            this.CargarGeneros();
            this.CargarNacionalidades();

            if(this.rut){
                this.form.rut = this.rut;
                this.BuscarPersona();
            }
        },
        methods: {
            BuscarPersona() {
                let self = this;

                // Cargamos URL
                axios.get('/data/personas/' + self.form.rut)
                    .then(response => {
                        if(response.data.code == 1){
                            self.persona = response.data.persona;

                            self.CargarFormulario();
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            CargarFormulario() {
                this.form.nombres = this.persona.nombres;
                this.form.apellido_paterno = this.persona.apellido_paterno;
                this.form.apellido_materno = this.persona.apellido_materno;
                this.form.genero_id = this.persona.genero_id;
                this.form.nacionalidad_id = this.persona.nacionalidad_id;
                this.form.email = this.persona.email;
                this.form.email2 = this.persona.email2;
                this.form.telefono = this.persona.telefono;
            },
            CargarGeneros() {
                let self = this;

                // Cargamos URL
                axios.get('/data/generos')
                    .then(response => {
                        self.form_data.generos = response.data.generos;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            CargarNacionalidades() {
                let self = this;

                // Cargamos URL
                axios.get('/data/nacionalidades')
                    .then(response => {
                        self.form_data.nacionalidades = response.data.nacionalidades;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
        }
    }
</script>
